import React from 'react';
import { modalAnim } from '../motion/keyframes.js';

// Feedback widget skeleton — panel-shaped, anchored bottom-right by default
// (matches the launcher → side-panel default). Painted instantly while the
// FeedbackRenderer chunk resolves.
export const FeedbackSkeleton: React.FC = () => {
  return (
    <div style={backdropStyle}>
      <div style={panelStyle} aria-busy="true" aria-label="Loading feedback widget">
        <div style={{ ...bar, width: '60%', height: 18, marginBottom: 16 }} />
        <div style={{ display: 'flex', gap: 8, marginBottom: 24 }}>
          {[0, 1, 2, 3, 4].map((i) => (
            <div key={i} style={{ ...bar, width: 36, height: 36, borderRadius: 18 }} />
          ))}
        </div>
        <div style={{ ...bar, width: '100%', height: 96, marginBottom: 16, borderRadius: 8 }} />
        <div style={{ ...bar, width: '100%', height: 36, borderRadius: 8 }} />
      </div>
    </div>
  );
};

const backdropStyle: React.CSSProperties = {
  position: 'fixed',
  inset: 0,
  pointerEvents: 'none',
};

const panelStyle: React.CSSProperties = {
  position: 'absolute',
  right: 16,
  bottom: 16,
  width: 360,
  maxWidth: 'calc(100vw - 32px)',
  background: '#ffffff',
  borderRadius: 12,
  padding: '24px 24px 28px',
  boxShadow: '0 12px 32px rgba(15, 23, 42, 0.18)',
  animation: modalAnim(),
  pointerEvents: 'auto',
};

const bar: React.CSSProperties = {
  background: '#e5e7eb',
  borderRadius: 6,
  animation: 'chirp-skeleton 1.4s ease-in-out infinite',
};
